import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as svc from './servicios-service';
import { serviciosKeys } from './keys';
import type { CreateServicioDto, UpdateServicioDto, QueryServiciosDto } from './servicios-service';

export function useServiciosList(params: QueryServiciosDto) {
  return useQuery({
    // SAFETY: Query DTOs are JSON-compatible records; the key helper only needs this structural view.
    queryKey: serviciosKeys.list(params as unknown as Record<string, unknown>),
    queryFn: () => svc.getServicios(params),
    staleTime: 30_000,
  });
}

export function useServiciosStats(params: Omit<QueryServiciosDto, 'offset' | 'limit'>) {
  return useQuery({
    // SAFETY: Query DTOs are JSON-compatible records; the key helper only needs this structural view.
    queryKey: serviciosKeys.stats(params as unknown as Record<string, unknown>),
    queryFn: () => svc.getServiciosStats(params),
    staleTime: 30_000,
  });
}

export function useServicio(id: number) {
  return useQuery({
    queryKey: serviciosKeys.detail(id),
    queryFn: () => svc.getServicio(id),
    enabled: id > 0,
    staleTime: 30_000,
  });
}

export function useCreateServicio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateServicioDto) => svc.createServicio(dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: serviciosKeys.all });
    },
  });
}

export function useUpdateServicio() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, dto }: { id: number; dto: UpdateServicioDto }) =>
      svc.updateServicio(id, dto),
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: serviciosKeys.detail(variables.id) });
      qc.invalidateQueries({ queryKey: serviciosKeys.all });
    },
  });
}
